var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-radio-group',{attrs:{"value":true,"row":"","dense":""}},[_c('v-radio',{attrs:{"label":"Active Rates","value":true}})],1),_c('v-divider',{staticClass:"my-5"}),_c('session-rates-report')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }